import type { Directive } from 'vue'

import { contentsquare } from '@shared/analytics/modules/contentsquare'
import { google } from '@shared/analytics/modules/google'
import { microsoftAdvertising } from '@shared/analytics/modules/microsoft-advertising'

type AnalyticsInstance = {
  contentsquare: Readonly<typeof contentsquare>
  google: Readonly<typeof google>
  microsoftAdvertising: Readonly<typeof microsoftAdvertising>
}

export const Analytics = (): Readonly<AnalyticsInstance> => ({
  contentsquare,
  google,
  microsoftAdvertising,
})

export const analytics = Analytics()

export const vTracking: Directive<HTMLElement, string | false> = {
  mounted: (el, binding) => {
    if (binding.value === false) {
      return
    }

    const attributes = analytics.contentsquare.getTrackingDataAttributes(
      binding.value
    )

    for (const [key, value] of Object.entries(attributes)) {
      el.setAttribute(key, value)
    }
  },
  getSSRProps: (binding) => {
    if (binding.value === false) {
      return
    }

    return analytics.contentsquare.getTrackingDataAttributes(binding.value)
  },
}
